import { clone, first, isPlainObject, set, values } from "lodash";

import { SKU, SKUPageContent, SKUUniqueContent, Tag } from "@/data/types";
import { SKUFormValues } from "@/lib/forms";

import { DEFAULT_NETWORK } from "./chains";

export type PreviewParams = Partial<SKUFormValues>;

// TODO: Segregate properties
// https://linear.app/legitimatetech/issue/ENG-1544/segregate-application-types-distinguishing-model-properties-from
export const getPreviewParamsFromSKU = (
  sku: SKU,
  overrides: Partial<Tag & SKU> = {},
): PreviewParams => {
  // TODO: Fix the nullish coalescing operator using functional programming

  return {
    name: sku.name ?? undefined,
    notes: sku.notes ?? undefined,
    description: sku.description ?? undefined,
    image_url: sku.image_url ?? undefined,
    animation_url: sku.animation_url ?? undefined,
    header_logo_url: sku.header_logo_url ?? undefined,
    builder_io_url: sku.builder_io_url ?? undefined,
    builder_io_api_key: sku.builder_io_api_key ?? undefined,
    login_options: sku.login_options ?? [],
    redirect_url: sku.redirect_url ?? undefined,
    nft_chain_id: sku.nft_chain_id ?? DEFAULT_NETWORK,
    page_type: sku.page_type,
    nft_token_id: 1,
    total_tags_count: sku.tags_count,
    page_content: sku.page_content,
    unique_content: sku.unique_content,
    display_serial_number: sku.display_serial_number,
    ...overrides,
  };
};

// FIXME: Migrate from doing these "combine" things and make a better way to build
// the preview params object

export const combinePageContentToSKU = (
  sku: SKU,
  pageContent: SKUPageContent | null,
) => {
  if (!isPlainObject(pageContent)) {
    return sku;
  }

  const combined = clone(sku);
  set(combined, "page_content", pageContent);

  return combined;
};

export const combineUniqueContentToSKU = (
  sku: SKU,
  uniqueContent: SKUUniqueContent | null,
) => {
  const firstTagMapValue = getFirstUniqueContentRow(uniqueContent);

  if (!firstTagMapValue) {
    return sku;
  }

  const combined = clone(sku);
  set(combined, "unique_content", firstTagMapValue);

  return combined;
};

export const getFirstUniqueContentRow = (
  uniqueContent?: SKUUniqueContent | null,
) => {
  const tagMapValues = values(uniqueContent?.tag_data_map);

  return first(tagMapValues);
};
